import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Modal, Button } from 'hosman-material';

import { purgeEstimationData } from '../../../../../../../reducers/_Pages/Public/estimationFunnelSlice';

const RestoreModal = ({ persitedStoreModalOpen, setPersitedStoreModalOpen }) => {
  const { estimationData: { typology } } = useSelector((state) => state.estimationFunnel);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!typology) return

    setPersitedStoreModalOpen(true)
  }, []);

  useEffect(() => {
    if (typology) return

    setPersitedStoreModalOpen(false)
  }, [typology]);

  const continueFunnel = () => {
    setPersitedStoreModalOpen(false);
    navigate(location.pathname, { replace: true });
  }

  const emptyPersistedStore = () => {
    setPersitedStoreModalOpen(false);
    dispatch(purgeEstimationData());
  }

  return (
    <Modal isOpen={persitedStoreModalOpen} closeModal={() => setPersitedStoreModalOpen(false)} width='w-full md:w-2/3'>
      <div className='flex flex-col gap-10 p-6 text-center text-ih-indigo' data-testid='RestoreModal'>
        <p className='h2'>Une estimation est déjà en cours</p>

        <p className='w-2/3 mx-auto'>Souhaitez-vous continuer cette estimation ou estimer un autre bien?</p>

        <div className='flex flex-col md:flex-row gap-3 justify-center'>
          <Button label='Nouvelle estimation' type='tertiary' onClick={() => emptyPersistedStore()} />
          <Button label='Continuer' onClick={() => continueFunnel()} />
        </div>
      </div>
    </Modal>
  )
}

export default RestoreModal;
